import { useEffect, useRef } from "react";
import MapArticleCard from "./map-article-card";
import "./map-right-column.css";

function TextDescription({ mapdescription }) {
  return (
    <div className="text-description-container">
      <p>{mapdescription}</p>
    </div>
  );
}

export default function RightColumn({ defaultProps, index, setActiveIndex }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    // Only run observer on desktop
    if (window.innerWidth <= 768) return;
    const currentSection = sectionRef.current;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActiveIndex(index); // 🔥 image swap trigger
        }
      },
      {
        threshold: 0.5,             // trigger as soon as section starts to appear
        rootMargin: "-40% 0px 0px 0px"
      }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [index, setActiveIndex]);

  return (
    <div className="right-column-container" ref={sectionRef}>
      <TextDescription mapdescription={defaultProps.map_description} />

      <MapArticleCard
        title={defaultProps.article_title_1}
        byline={defaultProps.article_byline_1}
        url={defaultProps.article_url_1}
        image={defaultProps.article_image_1}
      />

      <MapArticleCard
        title={defaultProps.article_title_2}
        byline={defaultProps.article_byline_2}
        url={defaultProps.article_url_2}
        image={defaultProps.article_image_2}
      />

      <MapArticleCard
        title={defaultProps.article_title_3}
        byline={defaultProps.article_byline_3}
        url={defaultProps.article_url_3}
        image={defaultProps.article_image_3}
      />
    </div>
  );
}
